export const usePageRedirects = () => {
  const showErrorPage = (error: ApiResponseError) => {
    throw createError({
      statusCode: 503,
      message: error.message,
      fatal: true,
    })
  }

  const redirectDeletedPage = async (province: string) => {
    await navigateTo(routes().cottageProvince({ slug: province }), {
      external: true,
      redirectCode: 301,
    })
  }

  return {
    showErrorPage,
    redirectDeletedPage,
  }
}
